export default __webpack_public_path__ + "static/media/02.2e15aeef.jpg";